import { useState } from 'react'
import { formatearPeso, formatearFecha, generarFolioTicket, generarTextoWhatsApp, generarLinkWhatsApp, LABEL_METODO } from '../../utils/formato'
import { useConfig } from '../../context/ConfigContext'

export default function ModalTicket({ venta, onCerrar }) {
  const folio = venta?._id ? `PJ-${venta._id.slice(-6).toUpperCase()}` : generarFolioTicket()
  const { config } = useConfig()
  const [telefono, setTelefono] = useState(venta?.clienteTelefono ?? '')

  if (!venta) return null

  const metodoLabel = LABEL_METODO[venta.metodoPago] ?? venta.metodoPago ?? 'Efectivo'

  function handleEnviarWhatsApp() {
    const texto = generarTextoWhatsApp(venta, config, folio)
    const link = generarLinkWhatsApp(telefono, texto)
    window.open(link)
  }
  const esEfectivo = venta.metodoPago === 'efectivo'
  const esFiado = venta.metodoPago === 'fiado'
  const totalDia = venta.totalDia ?? null

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="bg-tienda-surface rounded-3xl w-full max-w-sm overflow-hidden shadow-2xl">

        {/* Encabezado */}
        <div className="bg-tienda-accent p-5 text-center">
          <div className="w-14 h-14 bg-gray-900/20 rounded-full flex items-center justify-center mx-auto mb-2">
            <svg className="w-8 h-8 text-gray-900" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h2 className="text-gray-900 text-2xl font-bold">Venta registrada</h2>
          <p className="text-gray-900/70 text-sm mt-1">{formatearFecha(venta.fecha)}</p>
        </div>

        {/* Ticket */}
        <div className="p-5">
          <div className="ticket-imprimible bg-tienda-bg rounded-2xl p-4 font-mono text-sm space-y-1">
            <div className="text-center mb-3">
              <p className="text-tienda-text font-bold text-base">{config.nombreTienda}</p>
              <p className="text-tienda-muted text-xs">Folio: {folio}</p>
            </div>

            {/* Productos */}
            <div className="border-t border-dashed border-tienda-border pt-2 space-y-1">
              {venta.items.map(item => {
                const esKg = item.unidad === 'kg'
                const precioItem = esKg
                  ? (item.precioFinal ?? item.precio * item.cantidad)
                  : item.precio * item.cantidad
                return (
                  <div key={item._id} className="flex justify-between gap-2">
                    <span className="text-tienda-muted truncate">
                      {esKg ? `${item.cantidad}kg` : `${item.cantidad}x`} {item.nombre}
                    </span>
                    <span className="text-tienda-text flex-shrink-0">
                      {formatearPeso(precioItem)}
                    </span>
                  </div>
                )
              })}
            </div>

            {/* Total */}
            <div className="border-t border-dashed border-tienda-border pt-2 flex justify-between">
              <span className="font-bold text-tienda-text">TOTAL</span>
              <span className="font-bold text-tienda-accent text-base">{formatearPeso(venta.total)}</span>
            </div>

            {/* Pago */}
            <div className="border-t border-dashed border-tienda-border pt-2 space-y-1">
              <div className="flex justify-between text-xs">
                <span className="text-tienda-muted">Forma de pago</span>
                <span className="text-tienda-text font-semibold">{metodoLabel}</span>
              </div>
              {esEfectivo && venta.recibido != null && (
                <>
                  <div className="flex justify-between text-xs">
                    <span className="text-tienda-muted">Recibido</span>
                    <span className="text-tienda-text">{formatearPeso(venta.recibido)}</span>
                  </div>
                  <div className="flex justify-between text-xs">
                    <span className="text-tienda-muted">Cambio</span>
                    <span className="text-tienda-success font-bold">{formatearPeso(venta.cambio)}</span>
                  </div>
                </>
              )}
              {esFiado && venta.clienteNombre && (
                <div className="flex justify-between text-xs">
                  <span className="text-tienda-muted">Cliente</span>
                  <span className="text-tienda-danger font-bold">{venta.clienteNombre}</span>
                </div>
              )}
            </div>

            <p className="text-center text-tienda-muted text-xs pt-2">Gracias por su compra</p>

            {/* Momento WOW — total acumulado del día */}
            {totalDia != null && totalDia > 0 && (
              <div className="border-t border-dashed border-tienda-border pt-3 mt-1 text-center">
                <p className="text-tienda-success font-bold text-sm">
                  Hoy llevas {formatearPeso(totalDia)} en ventas
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Enviar por WhatsApp */}
        <div className="px-5 pb-3">
          <div className="border-t border-tienda-border pt-4">
            <p className="text-tienda-muted text-xs mb-2">Enviar ticket al cliente</p>
            <div className="flex gap-2">
              <input
                type="tel"
                inputMode="numeric"
                maxLength={10}
                placeholder="Número WhatsApp (10 dígitos)"
                value={telefono}
                onChange={e => setTelefono(e.target.value.replace(/\D/g, ''))}
                className="input-field flex-1 py-3 text-base"
              />
              <button
                onClick={handleEnviarWhatsApp}
                disabled={telefono.length < 10}
                className="flex items-center gap-2 px-4 py-3 rounded-2xl font-bold text-white bg-[#25D366] disabled:opacity-40 active:scale-95 transition-transform flex-shrink-0"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Enviar
              </button>
            </div>
          </div>
        </div>

        {/* Acciones */}
        <div className="px-5 pb-5">
          <button onClick={onCerrar} className="btn-primary w-full text-center text-base">Nueva venta</button>
        </div>
      </div>
    </div>
  )
}
